// extracted by mini-css-extract-plugin
module.exports = {"sidebar":"Main_sidebar__27C4l","content":"Main_content__3AO2u","wrapper":"Main_wrapper__3jR9U","row":"Main_row__AJOEi"};